// ** Styles
import { useState, useCallback, useEffect } from 'react';
import '@styles/react/apps/app-roads.scss';
import { useParams } from 'react-router-dom';
import { GetActivityById } from '../../../../graphql/Mutation';
import { useMutation } from '@apollo/client';
import WizardHorizontal from '../shared/Wizard';

const FIELDS = {
  video: ['status', 'name', 'description', 'video', 'type'],
  form: ['status', 'name', 'description', 'form', 'type'],
  friends: ['status', 'name', 'description', 'friends', 'type'],
  audio: ['status', 'name', 'description', 'audio', 'type', 'cover'],
  checklist: ['status', 'name', 'description', 'list', 'type'],
};

const EditActivity = () => {
  const { id } = useParams();
  const [loading, setLoading] = useState(true);
  const [values, setValues] = useState({});
  const [getActivityById] = useMutation(GetActivityById);

  const handleChangeType = useCallback(() => {
    setLoading(true);

    setTimeout(() => {
      setLoading(false);
    }, 1);
  }, []);

  const formatData = (data) => {
    const formatedData = {};
    FIELDS[data.type].map((key) => {
      formatedData[key] = data[key];
    });

    setLoading(() => {
      setValues(formatedData);

      return false;
    });
  };

  const handleFetch = useCallback(async () => {
    try {
      const {
        data: { getActivityById: data }
      } = await getActivityById({ variables: { activityId: id } });

      formatData(data);
      setLoading(false);
    } catch (e) {}
  }, []);

  useEffect(() => {
    handleFetch();
  }, [handleFetch]);

  return !loading ? (
    <WizardHorizontal
      editMode={true}
      defaultValues={values}
      handleChangeType={handleChangeType}
      type={values.type}
      activityId={id}
      loading={loading}
      data={values}
      setData={setValues}
    />
  ) : null;
};

export default EditActivity;
